<template>
  <div class="signup-wrapper">
    <div class="person-signup">
      <div class="line" />
      <div class="info" @click="checkRealName('person')">
        <div class="icon"></div>
        <div class="text">个人报名</div>
      </div>
    </div>
    <div class="group-signup">
      <div class="line" />
      <div class="info" @click="checkRealName('group')">
        <div class="icon"></div>
        <div class="text">集体报名</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    isRealName() {
      return this.$store.getters["isRealName"];
    },
    isLogin() {
      return this.$store.getters["isLogin"];
    },
  },
  methods: {
    checkRealName() {
      this.$router.push(`/training-list`);
    },
  },
};
</script>

<style lang="scss" scoped>
.signup-wrapper {
  position: absolute;
  top: 3.73rem;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  z-index: 12;
  .person-signup,
  .group-signup {
    width: 3.67rem;
    height: 2.08rem;
    margin-right: 1.16rem;
    cursor: pointer;
    position: relative;
    .line {
      width: 0.25rem;
      height: 0.03rem;
      background-color: #fff;
      position: absolute;
      left: 0.15rem;
      top: 0.77rem;
    }
    &:last-of-type {
      margin-right: 0;
    }
    .info {
      position: relative;
      .icon {
        width: 0.81rem;
        height: 0.78rem;
        margin: 0.37rem 0 0 1.37rem;
      }
      .text {
        margin-top: 0.22rem;
        font-size: 0.23rem;
        color: #fff;
        text-align: center;
        font-weight: blod;
      }
    }
    &.person-signup {
      background-image: url(../../../../assets/images/person-bg.png);
      background-size: cover;
      .info {
        .icon {
          background-image: url(../../../../assets/images/person-user.png);
          background-size: cover;
        }
      }
    }
    &.group-signup {
      background-image: url(../../../../assets/images/group-bg.png);
      background-size: cover;
      .info {
        .icon {
          background-image: url(../../../../assets/images/group-user.png);
          background-size: cover;
          margin-top: 0.48rem;
        }
        .text {
          margin-top: 0.1rem;
        }
      }
    }
  }
}
</style>